'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondsBefore.js
// module id = 701
// module chunks = 0